import {
    onUnmounted,
    ref,
} from "vue";

type EventListenerEntry = {
    eventName: string;
    handler: EventListener;
};

export function useEventSource(url = "/api/events") {
    const refSource = ref<EventSource | null>(null);
    const refActive = ref(true);
    const refListeners = ref<EventListenerEntry[]>([]);

    function close(): void {
        if (refSource.value) {
            refSource.value.close();
            refSource.value = null;
        }
    }

    function connect(): void {
        close();

        if (!refActive.value)
            return;

        const source = new EventSource(url, { withCredentials: true });

        for (const listener of refListeners.value)
            source.addEventListener(listener.eventName, listener.handler, { passive: true });

        refSource.value = source;
    }

    connect();

    onUnmounted(() => {
        refActive.value = false;
        close();
    });

    return {
        on<TPayload>(eventName: string, eventCb: (payload: TPayload) => void): void {
            const handler: EventListener = (event) => {
                if (event instanceof MessageEvent)
                    eventCb(JSON.parse(event.data));
            };

            refListeners.value.push({ eventName, handler });
            refSource.value?.addEventListener(eventName, handler);
        },
    };
}
